import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import React from 'react';
import Action from 'components/organisms/f1-per-team-driver-limits/actions';

class F1PerTeamDriverLimits extends Component {
    onClick(use) {
        this.props.dispatch(Action.useF1PerTeamDriverLimits(!use));
    }

    handleCheck(teamName) {
        this.props.dispatch(Action.setForTeam(teamName));
    }

    handleCheckAll(teamNames) {
        this.props.dispatch(Action.setForTeams(this.isAllTeamsDisallowed() ? teamNames : []));
    }

    render() {
        const {stacking} = this.props;
        const teamNames = this.getTeamNames();
        const isAllTeamsSelected = this.isAllTeamsDisallowed();

        return (
            <div className={`advanced-filter${stacking.isEnabled() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Close Per-team Driver Limits
                    </button>
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>Per-team Driver Limits
                    </button>
                </div>
                <div className="hitter-wrap white-box">
                    <h2>Disallow 2 D from the same team</h2>
                    <button
                        onClick={() => this.handleCheckAll(teamNames)}
                        type="button"
                        className={`checkbox-btn-block mb10`}
                    >
                        <span className={`checkbox-btn ${isAllTeamsSelected ? 'active' : ''}`} />
                        <span className="checkbox-btn-text">Check All</span>
                    </button>
                    <div className="f1-limits-container">
                        {teamNames.map((teamName) => (
                            <button
                                onClick={() => this.handleCheck(teamName)}
                                type="button"
                                className="chk-box"
                                key={teamName}
                            >
                                <span
                                    className={`checkbox-btn ${stacking.isTeamDisallowed(teamName) ? 'active' : ''}`}
                                />
                                <strong>{teamName}</strong>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        );
    }

    getTeamNames() {
        const {players} = this.props;

        const teamNames = players.getAllAsArr().map((player) => player.team);

        return arrayUnique(teamNames);
    }

    isAllTeamsDisallowed() {
        const {stacking} = this.props;

        return stacking.getAllTeamNames().length === 0;
    }
}

function mapStatesToProps(state) {
    const {f1PerTeamDriverLimits, playersData} = state;

    return {
        stacking: f1PerTeamDriverLimits,
        players: playersData.players,
    };
}

export default connect(mapStatesToProps)(F1PerTeamDriverLimits);
